module.exports = __webpack_public_path__ + "0acf7c2044f5a5922686f1f8656f4e7b.pdf";